var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      marginRight: 20
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2741_5945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5939 43.99L12.8168 34.0622H2.70036L7.73376 25.296L0 18.7933L9.49097 15.3086L7.75361 5.38082L17.2645 8.81585L22.3276 0.069458L27.4007 8.80591L36.9116 5.36098L35.1841 15.2888L44.6751 18.7536L36.9414 25.2761L41.9847 34.0324H31.8782L30.111 43.9602L22.3773 37.5072L14.5939 43.99ZM5.44044 32.444H14.1471L15.676 41.0117L22.3773 35.4323L29.0487 41.0117L30.5776 32.444H39.2744L34.9359 24.9088L41.5876 19.2996L33.417 16.3213L34.9061 7.75356L26.7256 10.7319L22.3773 3.16693L18.0189 10.6922L9.83845 7.71386L11.3376 16.2816L3.16697 19.2599L9.82851 24.8592L5.44044 32.444Z",
    fill: "#1F4A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7463 28.6715L14.8519 23.7771L15.9936 22.6354L19.7463 26.398L28.6714 17.4729L29.8131 18.6146L19.7463 28.6715Z",
    fill: "#1F4A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_5945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.6751,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBadge);
export default __webpack_public_path__ + "static/media/checkBadge.4a40975eb8d317ab52e3be26db171b40.svg";
export { ForwardRef as ReactComponent };